import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchTourProgramApprovalType } from "../../../domain/models/tour-program-approval/fetch-tour-program-approval";
import { FetchTourProgramApproval } from "../../../domain/useages/tour-program-approval/fetch-tour-program-approval";
import { RemoteFetchTourProgramApproval } from "../../../data/usecases/tour-program-approval/remote-fetch-tour-program-approval";

export interface FetchTourProgramApprovalInterface {
  FetchTourProgramApproval: FetchTourProgramApprovalType;
  FetchTourProgramApprovalState: FetchState;
  fetchTourProgramApproval: Function;
}

const initialStates = {
  FetchTourProgramApproval: {} as FetchTourProgramApprovalType,
  FetchTourProgramApprovalState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchTourProgramApprovalSlice: StateCreator<
  FetchTourProgramApprovalInterface
> = (set) => ({
  ...initialStates,
  fetchTourProgramApproval: async (filter: FetchTourProgramApproval.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchTourProgramApproval = new RemoteFetchTourProgramApproval(
      `${BASE_URL}${Endpoints.FETCH_TOUR_PROGRAM_APPROVAL}`,
  

      axiosHttpClient
    );

    set(() => ({ FetchTourProgramApprovalState: FetchState.LOADING }));
    let result = await remoteFetchTourProgramApproval.fetch(filter);
    return result;
  }
});


